export default __webpack_public_path__ + "static/media/ICONE_N-TOXICO-verde-01.ba338467.svg";